module.exports = __webpack_public_path__ + "static/fiji2-300x177-f67f4abe18eff4c446c7a933e804ee4b.png";